export default __webpack_public_path__ + "static/media/photo-1546623381-d6d69cd69955.84098cf1.jpeg";